const Formatters = {
  textToID(text: string, { slashesToDash = false } = {}) {
    let id = String(text || '').toLowerCase().replaceAll(' ', '-');

    if (slashesToDash) {
      id = id.replace('/', '-');
    }

    return id;
  },
  replaceChars(text: string) {
    const charsToReplace = {
      '&': 'and',
      ' ': '-',
      '/': '',
    };

    return text.replace(/[& /]/g, (current) => charsToReplace[current as keyof typeof charsToReplace]);
  },
  camelCaseWithoutSC(text: string) {
    return text
      .replace(/^[^A-Z0-9]+/gi, '')
      ?.toLowerCase()
      ?.replace(/([^A-Z0-9]+)(.)/gi, (match) => match.replace(/^[^A-Z0-9]+/gi, '').toUpperCase())
      ?.match(/[A-Z]{2,}(?=[A-Z][a-z]+[0-9]*|\b)|[A-Z]?[a-z]+[0-9]*|[A-Z]|[0-9]+/g)
      ?.join('');
  },
};

export default Formatters;
